<template>
  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 20px">
      <div class="operator">
        <el-row>
          <el-col :span="4" :offset="20">
            得分：{{ isjudged == 0 ? "未批改" : `${score} / ${maxScore}` }}
          </el-col>
        </el-row>
      </div>
      <el-form class="dataForm" ref="form" :disabled="disabled" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 单选 -->
            <div v-if="questionArray.t1[0]">
              <el-card v-for="(qu, idx1) in questionArray.t1" :key="idx1 + '1'">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.单选</span></el-divider>
                </div>

                <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea> 
                <span>
                  <b style="color:#00CC00">[{{ qu.qscore }}分]</b>
                  <b>(</b>
                  <span style="color:#00F">{{ qu.flag }}</span>
                  <b>)</b>&nbsp;&nbsp;
                     <span v-if="isjudged == 1 && (parameter.type == 0 || parameter.type == 2|| parameter.type == 5)">本题<el-tag size="mini"
                      :type="qu.rslt ? 'success' : 'danger'">{{ qu.rslt ? "正确" : "错误" }}</el-tag>，得<b style="color: #CC0000;">{{ qu.rscore || 0
                      }}</b>分。</span>
                </span>
                <div v-for="(ch, idx2) in qu.question.choiceList" :key="idx2 + '11'">
                  <el-button :class="ch.o==qu.flag?'bg-purple':''" plain>{{ ch.o }}.&nbsp;{{ ch.n }}</el-button>
                </div>
                <div style="width: 50%" v-if="qu.rigthAnsr">
                  <span style="color: #0c0;">标准答案：<br /><i style="color: #00f" v-html="qu.rigthAnsr">
                    </i></span>
                  <br />
                 <span v-if="qu.analysis" style="color: red;">题目解析:</span>
                  <span  style="color: #777;font-size: 12px;" v-html="qu.analysis"></span>
                  <!-- 题目解析按钮 -->
                  <el-button v-if="false"  :type="qu.stuanswer?'info':'success'"  size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析</el-button>
                </div>
              </el-card>
            </div>
            <!-- 多选 -->
            <div v-if="questionArray.t2[0]">
              <el-card v-for="(qu, idx1) in questionArray.t2" :key="idx1 + '2'">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.多选</span></el-divider>
                </div>

                <span> <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea> 
                  <b style="color:#00CC00">[{{ qu.qscore }}分]</b>
                  <b> (</b>
                  <b style="color:#00F" v-for="(j, idx2) in qu.flag" :key="idx2 + '22'">{{ j }}</b><b>) </b><span
                    v-if="isjudged == 1  && (parameter.type == 0 || parameter.type == 2 || parameter.type == 5)">
                    本题<el-tag size="mini" :type="handlerScoringSituation(qu.rslt).status">{{
                      handlerScoringSituation(qu.rslt).ctx }}</el-tag>得<b style="color: #CC0000;">{{ qu.rscore || 0 }}</b>分。</span></span>

                <div v-for="(ch, idx3) in qu.question.choiceList" :key="idx3 + '222'">
                  <el-button plain :class="shDuoselected(ch.o,qu.flag)">{{ ch.o }}.&nbsp;{{ ch.n }}</el-button>
                </div>
                <div style="width: 75%" v-if="qu.rigthAnsr">
                  <span style="color: #0c0">标准答案：<br /><i style="color: #00f" v-html="qu.rigthAnsr">
                    </i></span>
                  <br />
         <span v-if="qu.analysis" style="color: red;">题目解析:</span>
                  <span  style="color: #777;font-size: 12px;" v-html="qu.analysis"></span>

                  <!-- 题目解析按钮 -->
                  <el-button v-if="false" :type="qu.stuanswer?'info':'success'"    size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析111</el-button>
                </div>
              </el-card>
            </div>

            <!-- 判断 -->
            <div v-if="questionArray.t3[0]">
              <el-card v-for="(qu, idx1) in questionArray.t3" :key="idx1 + '3'">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.判断</span></el-divider>
                </div>

                <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}&nbsp;&nbsp;</b>
                <b>{{ qu.question.title }}</b>
                <b style="color:#00CC00">[{{ qu.qscore }}分]</b>
                <b>(</b> {{ qu.flag == 0 ? "X " : "V " }} <b> ) </b>
                <span v-if="isjudged == 1  && (parameter.type == 0 || parameter.type == 2|| parameter.type == 5)">&nbsp;&nbsp;本题<el-tag size="mini"
                    :type="qu.rslt ? 'success' : 'danger'">{{
                      qu.rslt ? "正确" : "错误" }}</el-tag>，得<b style="color: #CC0000;">{{ qu.rscore || 0 }}</b>分。</span>
                <br />

                <input :disabled="true" v-model="qu.flag" value="1" type="radio" :name="qu.id" />正确
                <input :disabled="true" v-model="qu.flag" value="0" type="radio" :name="qu.id" />错误
                <div style="width: 75%" v-if="qu.rigthAnsr">
                  <span style="color: #0c0">标准答案：<br /><i style="color: #00f" v-html="qu.rigthAnsr"></i></span>
                  <br />
                  <span v-if="qu.analysis" style="color: red;">题目解析:</span>
                  <span  style="color: #777;font-size: 12px;" v-html="qu.analysis"></span>
                  <!-- 题目解析按钮 -->
                  <el-button v-if="false"  :type="qu.stuanswer?'info':'success'"    size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析</el-button>
                </div>
              </el-card>
            </div>

            <!-- 简答、论述、编程题 -->
            <div v-if="questionArray.t5[0]">
              <el-card v-for="(qu, idx1) in questionArray.t5" :key="idx1 + '5'">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.简答</span></el-divider>
                </div>
                <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea> 
                <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
                <textarea :readonly="true" name="" id="" cols="100%" rows="5" v-model="qu.flag"></textarea>
                <div style="width: 75%" v-if="qu.rigthAnsr">
                  <span v-if="isjudged == 1  && (parameter.type == 0 || parameter.type == 2||parameter.type == 4 || parameter.type == 5)">得分判定：<b style="color: #CC0000;"> {{ qu.rscore || 0 }} </b>分。</span>
                  <br />
                  <span class="title-color-red">标准答案：<br /><span style="color: #777;font-size: 12px;"
                      v-html="qu.rigthAnsr"></span></span>
                  <br />
                  <span v-if="qu.ays" class="title-style-bold margin-top-20" style="color: blue;">解析得分:</span><br>
                  <span  style="color: #777;font-size: 12px;" v-html="qu.ays"></span>
                  <!-- 题目解析按钮 -->
                  <el-button  v-if="false"  :type="qu.stuanswer?'info':'success'"    size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析</el-button>
                </div>
              </el-card>
            </div>

            <div v-if="questionArray.t6[0]">
              <el-card v-for="(qu, idx1) in questionArray.t6" :key="idx1 + '6'">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.论述</span></el-divider>
                </div>
                <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea> 
                <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
                <textarea :readonly="true" name="" id="" cols="100%" rows="5" v-model="qu.flag"></textarea>
                <div style="width: 75%" v-if="qu.rigthAnsr">
                  <span v-if="isjudged == 1  && (parameter.type == 0 || parameter.type == 2)">得分判定：{{ qu.rscore || 0 }} 分。</span>
                  <br />
                  <span style="color: #0c0">标准答案：<br /><i style="color: #00f" v-html="qu.rigthAnsr"></i></span>
                  <br />
                  <span style="color: red;">题目解析:</span><br />
                  <!-- 题目解析按钮 -->
                  <el-button  v-if="false"  :type="qu.stuanswer?'info':'success'"    size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析</el-button>
                </div>
              </el-card>
            </div>
            <div v-if="questionArray.t7[0]">
              <el-card v-for="(qu, idx1) in questionArray.t7" :key="idx1 + '7'">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.编程题</span></el-divider>
                </div>
                <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="3" disabled v-model="qu.question.title"></textarea> 
                <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
                <textarea :readonly="true" name="" id="" cols="100%" rows="5" v-model="qu.flag"></textarea>

                <div style="width: 75%" v-if="qu.rigthAnsr">
                  <span v-if="isjudged == 1  && (parameter.type == 0 || parameter.type == 2)">得分判定：<span style="color: #CC0000;">  {{ qu.rscore || 0 }} </span>分。</span>
                  <br />
                  <span style="color: #0c0">标准答案：<br /><i style="color: #00f" v-html="qu.rigthAnsr">
                    </i></span>
                  <br />
                  <span style="color: red;">题目解析:</span><br />
                  <!-- 题目解析按钮 -->
                  <el-button  v-if="false"  :type="qu.stuanswer?'info':'success'"    size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析</el-button>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-form>

        <!-- 解析弹出面板 -->
        <el-dialog title="更新答案解析" :visible.sync="dialogFormVisible" :append-to-body="true" ref="analysisForm">
        <el-form :model="currentQuestion">
          <el-form-item label="答案">
            <el-input type="textarea" v-model="currentQuestion.rigthAnsr" rows="4"></el-input>
          </el-form-item>
          <el-form-item label="解析">
            <el-input type="textarea" v-model="currentQuestion.analysis" rows="8"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('cancel')">关 闭</el-button>
          <el-button type="danger"  v-if="!this.currentQuestion.stuanswer" @click="submitForm()">提交更新</el-button>
        </div>
      </el-dialog>

    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="21">
          <el-button v-if="!disabled" type="info" :loading="confirmLoading" @click="close()">关 闭</el-button>
        </el-col>
        <el-col :span="3"> </el-col>
      </el-row>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import apiAnsr from "@/api/exams/exams/answers.js";

export default {
  components: {
    popup,
    FillInTheBlanks,
  },
  data() {
    return {
      countDown: "",
      popupLoading: false,
      disabled: false,
      confirmLoading: false,

      flag1: 0,
      formParameter: {},

      parameter: {}, //exam
      kid: "", //考试id
      stuid: "", //当前学生

      exp: {}, //试卷
      expId: null, //试卷ID
      exmCnt: 0, //考试的人数
      score: 0, //当前得分
      maxScore: 0, //试卷总分
      typeTxArr: [],
      stuAnwser: {}, //学生自己答案

      //题类型位置
      choice_question: { show: false },
      //题数组
      questionArray: { t1: [], t2: [], t3: [], t4: [], t5: [], t6: [], t7: [] },
      dialogFormVisible: false, // 题目解析弹出是否可见
      currentQuestion: {}, // 当前题目的解析
      searchParams: {},

      // 是否判卷
      isjudged: 0,
      times: {},
    };
  },

  methods: {
    //回显button多选被选中
    shDuoselected(anr,uAnr){
        if(uAnr && uAnr.indexOf(anr)>-1){
            //选中
            return "bg-purple"
        }else{
            return ""
        }
    },
    //初始化学生答案对象
    initStudentAnswer() {
      this.flag1 = 1;

      api.getexpContent({ exid: this.kid }, (response) => {
        this.exp = JSON.parse(response.data);

        this.maxScore = this.exp.score;

        //题型
        let content = JSON.parse(this.exp.content);
       // console.log("题型",content);

        this.typeTxArr = content.types;
        this.typeTxArr.forEach((v, i) => {
          //初始化答案
          let qscore = content.contents[i].qscore;

          this.questionArray[`t${v}`] = this.exp.contents[i].qid;
          //回显答案
          this.questionArray[`t${v}`].forEach((v1, i1) => {
            v1.qscore = qscore[i1];
          });
        });
        //取得学生的答案
        this.getOneAnwser();
      });
    },
    getOneAnwser() {
      api.getOneAnswers({ kid: this.kid, sid: this.stuid }, (res) => {
        this.stuAnwser = res.data;
        // 拿到当前时间和试卷过期时间
        let { nowTime, endTime } = this.times;
        // 将过期时间转换为时间戳
        endTime = new Date(endTime).getTime();
        // 拿到改卷情况
        this.isjudged = res.data.isjudged;
        // 获取试卷得分
        this.score = this.stuAnwser.score;

        // 线上考试+覆盖考试
        if (this.stuAnwser.type == 0 || this.stuAnwser.type == 5) {
          // 获取学生答案
          let anwrArr = JSON.parse(this.stuAnwser.answer);
          //取得以前提交的成绩
          let scoredetail = null;
          if (this.stuAnwser.scoredetail) {
            scoredetail = JSON.parse(this.stuAnwser.scoredetail);
           // console.log("scoredetail",scoredetail)
          }
          // 迭代题目类型
          this.typeTxArr.forEach((v, i) => {
            let anwr = anwrArr[i];

            if (v <= 3   ) {   //单选、多选、判断   自动判题
              //取得本题型的的判题数组
              let subScoredetail = scoredetail[i]
               
              this.questionArray[`t${v}`].forEach((v1, i1) => {
                  v1.flag = anwr[i1];
                  
                  // 判卷结果
                  v1.rslt =  subScoredetail[i1].rslt ;
                  // 本题得分
                  v1.rscore =  subScoredetail[i1].rscore ;
              });
              
            } else {
              //主观题
              this.questionArray[`t${v}`].forEach((v1, i1) => {
                v1.flag = anwr[i1];
                //if (nowTime > endTime) {
                  // 判卷结果回显    scoredetail
                  if (scoredetail) {
                    v1.rscore = scoredetail[i][i1].rscore;
                    if(scoredetail[i][i1].ays){
                       v1.ays = scoredetail[i][i1].ays;
                    }
                  } else {
                    v1.rscore = 0;
                  }
                //}
              });
            }
          });
          // 面试考试
        } else if (this.stuAnwser.type == 2||this.stuAnwser.type==4) {
          // 获取学生答案
          let anwrArr = JSON.parse(this.stuAnwser.answer);
          console.log("学生答案",anwrArr);
          let queArray2 = { t1: [], t2: [], t3: [], t4: [], t5: [], t6: [], t7: [] };


          for (let v = 1; v <= 7; v++) {
            if (v != 4) {  //排除填空题
              this.questionArray[`t${v}`].forEach((v1, i1) => {
                for (let idx = 0; idx < anwrArr.length; idx++) {
                  const q = anwrArr[idx];
                  if (q.id == v1.id) {
                    v1.rscore = q.rscore
                    v1.qscore = q.qscore
                    queArray2[`t${v}`].push(v1)
                    break;
                  }
                }
              });
            }
          }


          this.questionArray = queArray2
          //线下考试
        } else {

        }

        // console.log('queArray2',queArray2)
        // console.log('this.questionArray' ,this.questionArray )
        //手动强制刷新
        this.$forceUpdate();
      });
    },

    //打开弹框
    open(kid, sid, title, times) {
      this.kid = kid;
      this.stuid = sid;
      this.times = times;
      //根据考试id取回试卷
      api.findPaperByKid({ kid: this.kid }, (res) => {
        //考试
        this.parameter = res.data.exm;
        //多选得分策略
        this.exp.duoxuan = 1;

        //试卷ID
        this.expId = this.parameter.expid;

        //已考试人数
        this.exmCnt = res.data.exmCnt;

        if (this.flag1 == 0) {
          //加载答案
          this.initStudentAnswer();
        }

        this.$refs.popup.open(title, "70%");
        //2. 发起请求 根据  考试ID +学生ID 查回一个试卷+答案

        this.disabled = false;
      });
    },
    close(done) {
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.score = 0;
      this.countDown = "";
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.parameter = {};
      this.flag1 = 0;
      this.formParameter = {};
      this.choice_question = { show: false };
      this.searchParams = {};
      this.currentQuestion = {};
      this.questionArray = {
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t6: [],
        t7: [],
      };
    },
    // 处理得分情况
    handlerScoringSituation(flag) {
      // 'success' : 'danger'
      var temp = {
        ctx: "",
        status: 0,
      };
      // 多题是否漏选得分
        if (flag == 1) {
          temp.ctx = "正确";
          temp.status = "success";
        } else if (flag == 2) {
          temp.ctx = "半对";
          temp.status = "warning";
        } else {
          temp.ctx = "错误";
          temp.status = "danger";
        }

      return temp;
    },
    // 初始化题目解析表单
    resetForm(status) {

      this.dialogFormVisible = false;
    },
    // 获取当前题目的解析内容
    getCurrentAnalysis(data) {
      this.currentQuestion = data;
      this.dialogFormVisible = true;
    },submitForm(){

        //取得自己
        let userInfo = this.$caches.user.get();

        let stuanswer ={sn:userInfo.name,uptm:new Date().format("yyyy-MM-dd"),
                           ansr:this.currentQuestion.rigthAnsr,anys:this.currentQuestion.analysis  };

         //提交学生答案更新
         apiAnsr.updateStuAnsr({id:this.currentQuestion.id, stuanswer: JSON.stringify(stuanswer)  },res=>{
                //刷新显示
                this.currentQuestion.stuanswer ="xxx"
                this.dialogFormVisible = false;
         });

    }

  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.text {
  display: inline-block;
  padding: 0 20px;
}

.operator {
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999;
}

.title-style-bold {
  color: #000;
  font-weight: bold;
}

.title-color-red {
  color: red;
}

.margin-top-20 {
  margin-top: 20px;
  display: block;
}

.update-note {
  display: block;
  margin-top: 20px;
}

.el-card,
textarea {
  margin-top: 10px;
}

textarea {
  padding: 10px 5px;
  margin-bottom: 10px;
}

.el-button {
  margin: 5px 0;
}
</style>
